import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { MAX_COUNT_BEKET, TYPE_AGE_BEKET } from 'shared/constants'
import { Button } from 'shared/ui/button'
import { ButtonInput } from 'shared/ui/button-input'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface OnChangeCount {
  name: string
  value: number | string
}

export interface Count {
  adult?: number
  child?: number
}

interface Props {
  data?: Count
  title?: string
  onChangeCountHandler?: (data?: Count) => void
}

const initialState: Count = {
  child: 0,
  adult: 1,
}

const LevelCount = ({ data, title, onChangeCountHandler }: Props) => {
  const { t } = useTranslation()

  const [state, setState] = useState<Count>(() => {
    if (data) {
      return {
        adult: data?.adult,
        child: data?.child,
      }
    } else {
      return initialState
    }
  })

  const onChange = ({ name, value }: OnChangeCount) => {
    setState((data) => {
      if (!data) return data

      switch (name) {
        case TYPE_AGE_BEKET.ADULTS:
        case TYPE_AGE_BEKET.CHILDREN:
          data[name] = typeof value === 'string' ? parseInt(value) : value
          break
      }

      return { ...data }
    })
  }

  const INITIAL_COUNT = [
    {
      name: TYPE_AGE_BEKET.ADULTS,
      title: t('adults'),
      subTitle: t('beket_content.adult_form'),
    },
    {
      name: TYPE_AGE_BEKET.CHILDREN,
      title: t('children'),
      subTitle: t('beket_content.child_form'),
    },
  ]

  const onSubmit = () => {
    let keyObject: keyof typeof state

    for (keyObject in state) {
      if (state[keyObject] !== data?.[keyObject]) {
        return onChangeCountHandler?.(state)
      }
    }

    return onChangeCountHandler?.(state)
  }

  const getMaxCountByAge = (state: Count, name: TYPE_AGE_BEKET) => {
    const resultDifference =
      MAX_COUNT_BEKET - ((state?.adult || 0) + (state?.child || 0))

    return resultDifference + state[name]!
  }

  const getMinCount = (name: TYPE_AGE_BEKET) => {
    if (name === TYPE_AGE_BEKET.ADULTS) return 1

    return 0
  }

  return (
    <div className={s.wrapperClass}>
      <div className={s.titleWrapper}>
        <span className="bold-20">{title}</span>
      </div>
      <div className={s.wrapperCountPassenger}>
        <Paper padding={[16]}>
          <div className={s.countPassenger}>
            {INITIAL_COUNT?.map((item, index) => (
              <div
                className={s.item}
                key={item.name + index}
              >
                <ButtonInput
                  title={item.title}
                  subTitle={item.subTitle}
                  value={state?.[item.name]}
                  minNumber={getMinCount(item.name)}
                  maxNumber={getMaxCountByAge(state, item.name)}
                  onChange={(num) => onChange({ name: item.name, value: num })}
                />
              </div>
            ))}
          </div>
        </Paper>
      </div>

      <Button
        onClick={onSubmit}
        className={s.text}
      >
        {t('select_without_date')}
      </Button>
    </div>
  )
}

export default LevelCount
